import React from "react";


import "./PrintMergePatients.scss";


function PrintMergePatients({ printRef, upDatedData }: any) {

  return (
    <div className="print-merge-patient-container" ref={printRef}>
      <div className="heading-section">Merge Patient Details</div>
      <table>
        <tr>
          <th>
            Merged Patient ID
          </th>
          <th>
            Merged Patient Name
          </th>
          <th>
            Phone Number
          </th>
          <th>
            Duplicate Count
          </th>
          <th>
            Duplucate Patient ID
          </th>
          <th>
            Duplicate Patients Names
          </th>
        </tr>
        {upDatedData &&
          Object.keys(upDatedData)?.length > 0 &&
          Object.keys(upDatedData)?.map((eachKey: any) => (
            <tr>
              <td>no data</td>
              <td>no name</td>
              <td>{eachKey}</td>
              <td>{upDatedData[eachKey].length}</td>
              <td>no data</td>
              <td>
                {upDatedData[eachKey].map((eachPat: any, index: any) => {
                  return eachPat?.name
                }).join(" , ")}
              </td>
            </tr>
          )
          )
        }
      </table>
    </div>
  )
}
export default PrintMergePatients
